/**
 * Country SEO i18n - Wave 3
 * Expands language coverage for countries with limited translations
 * Adds 8-15 language translations for: brazil, japan, korea, india, australia,
 * mexico, colombia, argentina, egypt, qatar, philippines, nigeria, kenya, south-africa, etc.
 */

import type { CountrySEOMap } from './country-seo-i18n-types';

export const COUNTRY_SEO_I18N_WAVE3: CountrySEOMap = {

  // ============ BRAZIL — expand beyond PT/ES/FR ============
  brazil: {
    de: {
      title: 'Call Center Brasilien | Portugiesischsprachiger Kundenservice | Call IT Dev',
      description: 'Call Center für Brasilien: portugiesischsprachige Agenten, CSAT 95%, ab 3 $/h. 60% Ersparnis vs São Paulo.',
      heroTitle: 'Call Center für Brasilien — Portugiesischsprachiger Support',
      heroSubtitle: 'Premium-Kundenservice auf Portugiesisch zu Nearshore-Preisen.',
    },
    it: {
      title: 'Call Center Brasile | Assistenza Clienti in Portoghese | Call IT Dev',
      description: 'Call center per il Brasile: agenti lusofoni, CSAT 95%, da 3 $/h. 60% risparmio vs São Paulo.',
      heroTitle: 'Call Center per il Brasile — Supporto in Portoghese',
      heroSubtitle: 'Assistenza clienti premium in portoghese a prezzi nearshore.',
    },
    nl: {
      title: 'Callcenter Brazilië | Portugeestalige Klantenservice | Call IT Dev',
      description: 'Callcenter voor Brazilië: Portugeestalige agenten, CSAT 95%, vanaf 3 $/u. 60% besparing vs São Paulo.',
      heroTitle: 'Callcenter voor Brazilië — Portugeestalige Klantenservice',
      heroSubtitle: 'Premium klantenservice in het Portugees.',
    },
    ar: {
      title: 'مركز اتصال البرازيل | خدمة عملاء بالبرتغالية | Call IT Dev',
      description: 'مركز اتصال للبرازيل: وكلاء ناطقون بالبرتغالية، CSAT 95%، من 3 $/ساعة. توفير 60%.',
      heroTitle: 'مركز اتصال للبرازيل — دعم بالبرتغالية',
      heroSubtitle: 'خدمة عملاء متميزة بالبرتغالية للسوق البرازيلي.',
    },
    zh: {
      title: '巴西呼叫中心 | 葡萄牙语客服外包 | Call IT Dev',
      description: '巴西呼叫中心外包：葡萄牙语母语座席，CSAT 95%，3美元/小时起。比圣保罗节省60%。',
      heroTitle: '巴西呼叫中心 — 葡萄牙语母语支持',
      heroSubtitle: '以nearshore价格提供优质葡萄牙语客户体验。',
    },
    ja: {
      title: 'ブラジルコールセンター | ポルトガル語サポート外注 | Call IT Dev',
      description: 'ブラジル向けコールセンター：ポルトガル語ネイティブ、CSAT 95%、3$/時間〜。サンパウロ比60%削減。',
      heroTitle: 'ブラジル向けコールセンター — ポルトガル語サポート',
      heroSubtitle: 'ニアショア価格でプレミアムなポルトガル語体験。',
    },
    ko: {
      title: '브라질 콜센터 | 포르투갈어 고객 서비스 | Call IT Dev',
      description: '브라질 콜센터: 포르투갈어 원어민 상담원, CSAT 95%, 시간당 3달러부터. 상파울루 대비 60% 절감.',
      heroTitle: '브라질 콜센터 — 포르투갈어 원어민 지원',
      heroSubtitle: '니어쇼어 가격으로 프리미엄 포르투갈어 경험.',
    },
    ru: {
      title: 'Колл-центр Бразилия | Португалоязычная поддержка | Call IT Dev',
      description: 'Колл-центр для Бразилии: португалоговорящие агенты, CSAT 95%, от 3 $/ч. 60% экономия.',
      heroTitle: 'Колл-центр для Бразилии — Португалоязычная поддержка',
      heroSubtitle: 'Премиум-обслуживание на португальском.',
    },
    pl: {
      title: 'Call Center Brazylia | Obsługa Klienta po Portugalsku | Call IT Dev',
      description: 'Call center dla Brazylii: agenci portugalskojęzyczni, CSAT 95%, od 3 $/h. 60% oszczędności.',
      heroTitle: 'Call Center dla Brazylii — Obsługa po Portugalsku',
      heroSubtitle: 'Premium obsługa klienta po portugalsku.',
    },
    tr: {
      title: 'Brezilya Çağrı Merkezi | Portekizce Müşteri Hizmetleri | Call IT Dev',
      description: 'Brezilya için çağrı merkezi: Portekizce konuşan acenteler, CSAT %95, 3 $/saatten.',
      heroTitle: 'Brezilya İçin Çağrı Merkezi — Portekizce Destek',
      heroSubtitle: 'Nearshore fiyatlarla premium Portekizce müşteri deneyimi.',
    },
    sv: {
      title: 'Callcenter Brasilien | Portugisisktalande Kundtjänst | Call IT Dev',
      description: 'Callcenter för Brasilien: portugisisktalande agenter, CSAT 95%, från 3 $/h. 60% besparing.',
      heroTitle: 'Callcenter för Brasilien — Portugisisktalande Kundtjänst',
      heroSubtitle: 'Premium kundtjänst på portugisiska.',
    },
    da: {
      title: 'Callcenter Brasilien | Portugisisktalende Kundeservice | Call IT Dev',
      description: 'Callcenter til Brasilien: portugisisktalende agenter, CSAT 95%, fra 3 $/t. 60% besparelse.',
      heroTitle: 'Callcenter til Brasilien — Portugisisktalende Kundeservice',
      heroSubtitle: 'Premium kundeservice på portugisisk.',
    },
  },

  // ============ JAPAN — expand beyond JA/FR ============
  japan: {
    de: {
      title: 'Call Center Japan | Japanischsprachiger Kundenservice | Call IT Dev',
      description: 'Call Center für Japan: mehrsprachige Agenten, CSAT 95%, ab 3 $/h. 65% Ersparnis vs Tokio.',
      heroTitle: 'Call Center für Japan — Mehrsprachiger Support',
      heroSubtitle: 'Premium-Kundenservice für den japanischen Markt.',
    },
    es: {
      title: 'Call Center Japón | Atención al Cliente 24/7 | Call IT Dev',
      description: 'Call center para Japón: agentes multilingües, CSAT 95%, desde 3 $/h. 65% ahorro vs Tokio.',
      heroTitle: 'Call Center para Japón — Soporte Multilingüe',
      heroSubtitle: 'Atención al cliente premium para el mercado japonés.',
    },
    ar: {
      title: 'مركز اتصال اليابان | خدمة عملاء متعددة اللغات | Call IT Dev',
      description: 'مركز اتصال لليابان: وكلاء متعددو اللغات، CSAT 95%، من 3 $/ساعة. توفير 65%.',
      heroTitle: 'مركز اتصال لليابان — دعم متعدد اللغات',
      heroSubtitle: 'خدمة عملاء متميزة للسوق الياباني.',
    },
    zh: {
      title: '日本呼叫中心 | 多语种客服外包 | Call IT Dev',
      description: '日本呼叫中心外包：多语种座席，CSAT 95%，3美元/小时起。比东京节省65%。',
      heroTitle: '日本呼叫中心 — 多语种客服支持',
      heroSubtitle: '为日本市场提供优质客户服务。',
    },
    ko: {
      title: '일본 콜센터 | 다국어 고객 서비스 | Call IT Dev',
      description: '일본 콜센터: 다국어 상담원, CSAT 95%, 시간당 3달러부터. 도쿄 대비 65% 절감.',
      heroTitle: '일본 콜센터 — 다국어 지원',
      heroSubtitle: '일본 시장을 위한 프리미엄 고객 서비스.',
    },
    ru: {
      title: 'Колл-центр Япония | Многоязычная поддержка | Call IT Dev',
      description: 'Колл-центр для Японии: многоязычные агенты, CSAT 95%, от 3 $/ч. 65% экономия vs Токио.',
      heroTitle: 'Колл-центр для Японии — Многоязычная поддержка',
      heroSubtitle: 'Премиум-обслуживание для японского рынка.',
    },
    it: {
      title: 'Call Center Giappone | Assistenza Multilingue | Call IT Dev',
      description: 'Call center per il Giappone: agenti multilingue, CSAT 95%, da 3 $/h. 65% risparmio vs Tokyo.',
      heroTitle: 'Call Center per il Giappone — Supporto Multilingue',
      heroSubtitle: 'Assistenza clienti premium per il mercato giapponese.',
    },
    pt: {
      title: 'Call Center Japão | Atendimento Multilingue | Call IT Dev',
      description: 'Call center para Japão: agentes multilingues, CSAT 95%, a partir de 3 $/h. 65% economia vs Tóquio.',
      heroTitle: 'Call Center para Japão — Suporte Multilingue',
      heroSubtitle: 'Atendimento premium para o mercado japonês.',
    },
    tr: {
      title: 'Japonya Çağrı Merkezi | Çok Dilli Müşteri Hizmetleri | Call IT Dev',
      description: 'Japonya için çağrı merkezi: çok dilli acenteler, CSAT %95, 3 $/saatten.',
      heroTitle: 'Japonya İçin Çağrı Merkezi — Çok Dilli Destek',
      heroSubtitle: 'Japon pazarı için premium müşteri deneyimi.',
    },
  },

  // ============ KOREA — expand beyond KO/FR ============
  korea: {
    de: {
      title: 'Call Center Südkorea | Kundenservice | Call IT Dev',
      description: 'Call Center für Südkorea: mehrsprachige Agenten, CSAT 95%, ab 3 $/h. 65% Ersparnis vs Seoul.',
      heroTitle: 'Call Center für Südkorea — Mehrsprachiger Support',
      heroSubtitle: 'Premium-Kundenservice für den koreanischen Markt.',
    },
    es: {
      title: 'Call Center Corea del Sur | Atención al Cliente | Call IT Dev',
      description: 'Call center para Corea del Sur: agentes multilingües, CSAT 95%, desde 3 $/h.',
      heroTitle: 'Call Center para Corea del Sur — Soporte Multilingüe',
      heroSubtitle: 'Atención al cliente premium para el mercado coreano.',
    },
    ar: {
      title: 'مركز اتصال كوريا الجنوبية | خدمة عملاء | Call IT Dev',
      description: 'مركز اتصال لكوريا: وكلاء متعددو اللغات، CSAT 95%، من 3 $/ساعة.',
      heroTitle: 'مركز اتصال لكوريا الجنوبية — دعم متعدد اللغات',
      heroSubtitle: 'خدمة عملاء متميزة للسوق الكوري.',
    },
    ja: {
      title: '韓国コールセンター | カスタマーサポート外注 | Call IT Dev',
      description: '韓国向けコールセンター：多言語対応、CSAT 95%、3$/時間〜。ソウル比65%削減。',
      heroTitle: '韓国向けコールセンター — 多言語サポート',
      heroSubtitle: '韓国市場向けプレミアムカスタマーサービス。',
    },
    zh: {
      title: '韩国呼叫中心 | 多语种客服外包 | Call IT Dev',
      description: '韩国呼叫中心外包：多语种座席，CSAT 95%，3美元/小时起。比首尔节省65%。',
      heroTitle: '韩国呼叫中心 — 多语种客服支持',
      heroSubtitle: '为韩国市场提供优质客户服务。',
    },
    ru: {
      title: 'Колл-центр Южная Корея | Поддержка 24/7 | Call IT Dev',
      description: 'Колл-центр для Южной Кореи: многоязычные агенты, CSAT 95%, от 3 $/ч.',
      heroTitle: 'Колл-центр для Южной Кореи — Многоязычная поддержка',
      heroSubtitle: 'Премиум-обслуживание для корейского рынка.',
    },
    it: {
      title: 'Call Center Corea del Sud | Assistenza Multilingue | Call IT Dev',
      description: 'Call center per la Corea del Sud: agenti multilingue, CSAT 95%, da 3 $/h.',
      heroTitle: 'Call Center per la Corea del Sud — Supporto Multilingue',
      heroSubtitle: 'Assistenza premium per il mercato coreano.',
    },
    pt: {
      title: 'Call Center Coreia do Sul | Atendimento Multilingue | Call IT Dev',
      description: 'Call center para Coreia do Sul: agentes multilingues, CSAT 95%, a partir de 3 $/h.',
      heroTitle: 'Call Center para Coreia do Sul — Suporte Multilingue',
      heroSubtitle: 'Atendimento premium para o mercado coreano.',
    },
  },

  // ============ INDIA — expand beyond FR ============
  india: {
    de: {
      title: 'Call Center Indien | Premium BPO Alternative | Call IT Dev',
      description: 'Premium-Alternative zum indischen BPO: mehrsprachige Agenten, CSAT 95%, CET-Zeitzone. Nearshore-Qualität.',
      heroTitle: 'Call Center für Indien — Premium Nearshore Alternative',
      heroSubtitle: 'Qualitativ hochwertige Alternative zum Offshore-BPO.',
    },
    es: {
      title: 'Call Center India | Alternativa Premium BPO | Call IT Dev',
      description: 'Alternativa premium al BPO indio: agentes multilingües, CSAT 95%, zona CET.',
      heroTitle: 'Call Center para India — Alternativa Premium Nearshore',
      heroSubtitle: 'Alternativa de calidad superior al BPO offshore indio.',
    },
    ar: {
      title: 'مركز اتصال الهند | بديل BPO متميز | Call IT Dev',
      description: 'بديل متميز لـ BPO الهندي: وكلاء متعددو اللغات، CSAT 95%، منطقة CET.',
      heroTitle: 'مركز اتصال للهند — بديل nearshore متميز',
      heroSubtitle: 'بديل عالي الجودة لـ BPO الهندي.',
    },
    zh: {
      title: '印度呼叫中心 | 高端BPO替代方案 | Call IT Dev',
      description: '印度BPO高端替代：多语种座席，CSAT 95%，CET时区。nearshore品质。',
      heroTitle: '印度呼叫中心 — 高端Nearshore替代方案',
      heroSubtitle: '优于离岸BPO的高品质替代方案。',
    },
    ja: {
      title: 'インドコールセンター | プレミアムBPO代替 | Call IT Dev',
      description: 'インドBPOのプレミアム代替：多言語対応、CSAT 95%、CET時間帯。',
      heroTitle: 'インド向けコールセンター — プレミアムニアショア代替',
      heroSubtitle: 'オフショアBPOの高品質代替。',
    },
    ko: {
      title: '인도 콜센터 | 프리미엄 BPO 대안 | Call IT Dev',
      description: '인도 BPO 프리미엄 대안: 다국어 상담원, CSAT 95%, CET 시간대.',
      heroTitle: '인도 콜센터 — 프리미엄 니어쇼어 대안',
      heroSubtitle: '오프쇼어 BPO의 고품질 대안.',
    },
    ru: {
      title: 'Колл-центр Индия | Премиум альтернатива BPO | Call IT Dev',
      description: 'Премиум-альтернатива индийскому BPO: многоязычные агенты, CSAT 95%, CET.',
      heroTitle: 'Колл-центр для Индии — Премиум Nearshore альтернатива',
      heroSubtitle: 'Высококачественная альтернатива офшорному BPO.',
    },
    it: {
      title: 'Call Center India | Alternativa Premium BPO | Call IT Dev',
      description: 'Alternativa premium al BPO indiano: agenti multilingue, CSAT 95%, fuso CET.',
      heroTitle: 'Call Center per l\'India — Alternativa Premium Nearshore',
      heroSubtitle: 'Alternativa di qualità superiore al BPO offshore.',
    },
    pt: {
      title: 'Call Center Índia | Alternativa Premium BPO | Call IT Dev',
      description: 'Alternativa premium ao BPO indiano: agentes multilingues, CSAT 95%, fuso CET.',
      heroTitle: 'Call Center para Índia — Alternativa Premium Nearshore',
      heroSubtitle: 'Alternativa de qualidade superior ao BPO offshore.',
    },
    tr: {
      title: 'Hindistan Çağrı Merkezi | Premium BPO Alternatifi | Call IT Dev',
      description: 'Hint BPO\'suna premium alternatif: çok dilli acenteler, CSAT %95, CET.',
      heroTitle: 'Hindistan İçin Çağrı Merkezi — Premium Nearshore Alternatif',
      heroSubtitle: 'Offshore BPO\'ya yüksek kaliteli alternatif.',
    },
  },

  // ============ AUSTRALIA — expand beyond FR ============
  australia: {
    de: {
      title: 'Call Center Australien | Englischsprachiger Kundenservice | Call IT Dev',
      description: 'Call Center für Australien: englischsprachige Agenten, 24/7, CSAT 95%, ab 3 $/h.',
      heroTitle: 'Call Center für Australien — Englischsprachiger Support 24/7',
      heroSubtitle: 'Premium-Kundenservice für den australischen Markt.',
    },
    es: {
      title: 'Call Center Australia | Atención al Cliente 24/7 | Call IT Dev',
      description: 'Call center para Australia: agentes anglófonos, 24/7, CSAT 95%, desde 3 $/h.',
      heroTitle: 'Call Center para Australia — Soporte Anglófono 24/7',
      heroSubtitle: 'Atención al cliente premium para el mercado australiano.',
    },
    ar: {
      title: 'مركز اتصال أستراليا | خدمة عملاء 24/7 | Call IT Dev',
      description: 'مركز اتصال لأستراليا: وكلاء ناطقون بالإنجليزية، 24/7، CSAT 95%، من 3 $/ساعة.',
      heroTitle: 'مركز اتصال لأستراليا — دعم بالإنجليزية 24/7',
      heroSubtitle: 'خدمة عملاء متميزة للسوق الأسترالي.',
    },
    zh: {
      title: '澳大利亚呼叫中心 | 英语客服外包 24/7 | Call IT Dev',
      description: '澳大利亚呼叫中心外包：英语母语座席，24/7，CSAT 95%，3美元/小时起。',
      heroTitle: '澳大利亚呼叫中心 — 英语客服 24/7',
      heroSubtitle: '为澳大利亚市场提供优质客户服务。',
    },
    ja: {
      title: 'オーストラリアコールセンター | 英語サポート 24/7 | Call IT Dev',
      description: 'オーストラリア向けコールセンター：英語ネイティブ、24/7、CSAT 95%、3$/時間〜。',
      heroTitle: 'オーストラリア向けコールセンター — 英語サポート 24/7',
      heroSubtitle: 'オーストラリア市場向けプレミアム顧客体験。',
    },
    ko: {
      title: '호주 콜센터 | 영어 고객 서비스 24/7 | Call IT Dev',
      description: '호주 콜센터: 영어 원어민 상담원, 24/7, CSAT 95%, 시간당 3달러부터.',
      heroTitle: '호주 콜센터 — 영어 지원 24/7',
      heroSubtitle: '호주 시장을 위한 프리미엄 고객 서비스.',
    },
    it: {
      title: 'Call Center Australia | Assistenza Anglofona 24/7 | Call IT Dev',
      description: 'Call center per l\'Australia: agenti anglofoni, 24/7, CSAT 95%, da 3 $/h.',
      heroTitle: 'Call Center per l\'Australia — Supporto Anglofono 24/7',
      heroSubtitle: 'Assistenza premium per il mercato australiano.',
    },
    pt: {
      title: 'Call Center Austrália | Atendimento em Inglês 24/7 | Call IT Dev',
      description: 'Call center para Austrália: agentes anglófonos, 24/7, CSAT 95%, a partir de 3 $/h.',
      heroTitle: 'Call Center para Austrália — Suporte em Inglês 24/7',
      heroSubtitle: 'Atendimento premium para o mercado australiano.',
    },
    ru: {
      title: 'Колл-центр Австралия | Англоязычная поддержка 24/7 | Call IT Dev',
      description: 'Колл-центр для Австралии: англоговорящие агенты, 24/7, CSAT 95%, от 3 $/ч.',
      heroTitle: 'Колл-центр для Австралии — Англоязычная поддержка 24/7',
      heroSubtitle: 'Премиум-обслуживание для австралийского рынка.',
    },
  },

  // ============ MEXICO — expand beyond ES/FR ============
  mexico: {
    de: {
      title: 'Call Center Mexiko | Spanischsprachiger Kundenservice | Call IT Dev',
      description: 'Call Center für Mexiko: spanischsprachige Agenten, CSAT 95%, ab 3 $/h. 55% Ersparnis.',
      heroTitle: 'Call Center für Mexiko — Spanischsprachiger Support',
      heroSubtitle: 'Premium-Kundenservice für den mexikanischen Markt.',
    },
    ar: {
      title: 'مركز اتصال المكسيك | خدمة عملاء بالإسبانية | Call IT Dev',
      description: 'مركز اتصال للمكسيك: وكلاء ناطقون بالإسبانية، CSAT 95%، من 3 $/ساعة.',
      heroTitle: 'مركز اتصال للمكسيك — دعم بالإسبانية',
      heroSubtitle: 'خدمة عملاء متميزة للسوق المكسيكي.',
    },
    pt: {
      title: 'Call Center México | Atendimento em Espanhol | Call IT Dev',
      description: 'Call center para México: agentes hispanófonos, CSAT 95%, a partir de 3 $/h. 55% economia.',
      heroTitle: 'Call Center para México — Suporte em Espanhol',
      heroSubtitle: 'Atendimento premium para o mercado mexicano.',
    },
    zh: {
      title: '墨西哥呼叫中心 | 西班牙语客服外包 | Call IT Dev',
      description: '墨西哥呼叫中心：西班牙语母语座席，CSAT 95%，3美元/小时起。',
      heroTitle: '墨西哥呼叫中心 — 西班牙语客服支持',
      heroSubtitle: '为墨西哥市场提供优质客户服务。',
    },
    ja: {
      title: 'メキシココールセンター | スペイン語サポート | Call IT Dev',
      description: 'メキシコ向けコールセンター：スペイン語ネイティブ、CSAT 95%、3$/時間〜。',
      heroTitle: 'メキシコ向けコールセンター — スペイン語サポート',
      heroSubtitle: 'メキシコ市場向けプレミアム顧客体験。',
    },
    ko: {
      title: '멕시코 콜센터 | 스페인어 고객 서비스 | Call IT Dev',
      description: '멕시코 콜센터: 스페인어 원어민 상담원, CSAT 95%, 시간당 3달러부터.',
      heroTitle: '멕시코 콜센터 — 스페인어 지원',
      heroSubtitle: '멕시코 시장을 위한 프리미엄 고객 서비스.',
    },
    ru: {
      title: 'Колл-центр Мексика | Испаноязычная поддержка | Call IT Dev',
      description: 'Колл-центр для Мексики: испаноговорящие агенты, CSAT 95%, от 3 $/ч.',
      heroTitle: 'Колл-центр для Мексики — Испаноязычная поддержка',
      heroSubtitle: 'Премиум-обслуживание для мексиканского рынка.',
    },
    it: {
      title: 'Call Center Messico | Assistenza in Spagnolo | Call IT Dev',
      description: 'Call center per il Messico: agenti ispanofoni, CSAT 95%, da 3 $/h.',
      heroTitle: 'Call Center per il Messico — Supporto in Spagnolo',
      heroSubtitle: 'Assistenza premium per il mercato messicano.',
    },
  },

  // ============ EGYPT — expand beyond AR/FR ============
  egypt: {
    de: {
      title: 'Call Center Ägypten | Arabischsprachiger Kundenservice | Call IT Dev',
      description: 'Call Center für Ägypten: arabischsprachige Agenten, CSAT 95%, ab 3 $/h.',
      heroTitle: 'Call Center für Ägypten — Arabischsprachiger Support',
      heroSubtitle: 'Premium-Kundenservice für den ägyptischen Markt.',
    },
    es: {
      title: 'Call Center Egipto | Atención al Cliente en Árabe | Call IT Dev',
      description: 'Call center para Egipto: agentes arabófonos, CSAT 95%, desde 3 $/h.',
      heroTitle: 'Call Center para Egipto — Soporte en Árabe',
      heroSubtitle: 'Atención al cliente premium para el mercado egipcio.',
    },
    it: {
      title: 'Call Center Egitto | Assistenza in Arabo | Call IT Dev',
      description: 'Call center per l\'Egitto: agenti arabofoni, CSAT 95%, da 3 $/h.',
      heroTitle: 'Call Center per l\'Egitto — Supporto in Arabo',
      heroSubtitle: 'Assistenza premium per il mercato egiziano.',
    },
    zh: {
      title: '埃及呼叫中心 | 阿拉伯语客服外包 | Call IT Dev',
      description: '埃及呼叫中心外包：阿拉伯语母语座席，CSAT 95%，3美元/小时起。',
      heroTitle: '埃及呼叫中心 — 阿拉伯语客服支持',
      heroSubtitle: '为埃及市场提供优质客户服务。',
    },
    tr: {
      title: 'Mısır Çağrı Merkezi | Arapça Müşteri Hizmetleri | Call IT Dev',
      description: 'Mısır için çağrı merkezi: Arapça konuşan acenteler, CSAT %95, 3 $/saatten.',
      heroTitle: 'Mısır İçin Çağrı Merkezi — Arapça Destek',
      heroSubtitle: 'Mısır pazarı için premium müşteri deneyimi.',
    },
    ru: {
      title: 'Колл-центр Египет | Арабоязычная поддержка | Call IT Dev',
      description: 'Колл-центр для Египта: арабоговорящие агенты, CSAT 95%, от 3 $/ч.',
      heroTitle: 'Колл-центр для Египта — Арабоязычная поддержка',
      heroSubtitle: 'Премиум-обслуживание для египетского рынка.',
    },
  },

  // ============ QATAR — expand beyond AR/FR ============
  qatar: {
    de: {
      title: 'Call Center Katar | Mehrsprachiger Kundenservice | Call IT Dev',
      description: 'Call Center für Katar: arabisch- und englischsprachige Agenten, CSAT 95%, ab 3 $/h.',
      heroTitle: 'Call Center für Katar — Mehrsprachiger Support',
      heroSubtitle: 'Premium-Kundenservice für den katarischen Markt.',
    },
    es: {
      title: 'Call Center Catar | Atención Multilingüe | Call IT Dev',
      description: 'Call center para Catar: agentes árabes e ingleses, CSAT 95%, desde 3 $/h.',
      heroTitle: 'Call Center para Catar — Soporte Multilingüe',
      heroSubtitle: 'Atención al cliente premium para el mercado catarí.',
    },
    it: {
      title: 'Call Center Qatar | Assistenza Multilingue | Call IT Dev',
      description: 'Call center per il Qatar: agenti arabofoni e anglofoni, CSAT 95%, da 3 $/h.',
      heroTitle: 'Call Center per il Qatar — Supporto Multilingue',
      heroSubtitle: 'Assistenza premium per il mercato del Qatar.',
    },
    zh: {
      title: '卡塔尔呼叫中心 | 多语种客服外包 | Call IT Dev',
      description: '卡塔尔呼叫中心外包：阿拉伯语和英语座席，CSAT 95%，3美元/小时起。',
      heroTitle: '卡塔尔呼叫中心 — 多语种客服支持',
      heroSubtitle: '为卡塔尔市场提供优质客户服务。',
    },
    tr: {
      title: 'Katar Çağrı Merkezi | Çok Dilli Müşteri Hizmetleri | Call IT Dev',
      description: 'Katar için çağrı merkezi: Arapça ve İngilizce acenteler, CSAT %95.',
      heroTitle: 'Katar İçin Çağrı Merkezi — Çok Dilli Destek',
      heroSubtitle: 'Katar pazarı için premium müşteri deneyimi.',
    },
    ru: {
      title: 'Колл-центр Катар | Многоязычная поддержка | Call IT Dev',
      description: 'Колл-центр для Катара: арабо- и англоговорящие агенты, CSAT 95%.',
      heroTitle: 'Колл-центр для Катара — Многоязычная поддержка',
      heroSubtitle: 'Премиум-обслуживание для катарского рынка.',
    },
  },

  // ============ COLOMBIA — expand beyond ES/FR ============
  colombia: {
    de: {
      title: 'Call Center Kolumbien | Spanischsprachiger Kundenservice | Call IT Dev',
      description: 'Call Center für Kolumbien: spanischsprachige Agenten, CSAT 95%, ab 3 $/h.',
      heroTitle: 'Call Center für Kolumbien — Spanischsprachiger Support',
      heroSubtitle: 'Premium-Kundenservice für den kolumbianischen Markt.',
    },
    ar: {
      title: 'مركز اتصال كولومبيا | خدمة عملاء بالإسبانية | Call IT Dev',
      description: 'مركز اتصال لكولومبيا: وكلاء ناطقون بالإسبانية، CSAT 95%، من 3 $/ساعة.',
      heroTitle: 'مركز اتصال لكولومبيا — دعم بالإسبانية',
      heroSubtitle: 'خدمة عملاء متميزة للسوق الكولومبي.',
    },
    pt: {
      title: 'Call Center Colômbia | Atendimento em Espanhol | Call IT Dev',
      description: 'Call center para Colômbia: agentes hispanófonos, CSAT 95%, a partir de 3 $/h.',
      heroTitle: 'Call Center para Colômbia — Suporte em Espanhol',
      heroSubtitle: 'Atendimento premium para o mercado colombiano.',
    },
    zh: {
      title: '哥伦比亚呼叫中心 | 西班牙语客服 | Call IT Dev',
      description: '哥伦比亚呼叫中心：西班牙语座席，CSAT 95%，3美元/小时起。',
      heroTitle: '哥伦比亚呼叫中心 — 西班牙语支持',
      heroSubtitle: '为哥伦比亚市场提供优质客户服务。',
    },
    it: {
      title: 'Call Center Colombia | Assistenza in Spagnolo | Call IT Dev',
      description: 'Call center per la Colombia: agenti ispanofoni, CSAT 95%, da 3 $/h.',
      heroTitle: 'Call Center per la Colombia — Supporto in Spagnolo',
      heroSubtitle: 'Assistenza premium per il mercato colombiano.',
    },
    ru: {
      title: 'Колл-центр Колумбия | Испаноязычная поддержка | Call IT Dev',
      description: 'Колл-центр для Колумбии: испаноговорящие агенты, CSAT 95%, от 3 $/ч.',
      heroTitle: 'Колл-центр для Колумбии — Испаноязычная поддержка',
      heroSubtitle: 'Премиум-обслуживание для колумбийского рынка.',
    },
  },

  // ============ ARGENTINA — expand beyond ES/FR ============
  argentina: {
    de: {
      title: 'Call Center Argentinien | Spanischsprachiger Kundenservice | Call IT Dev',
      description: 'Call Center für Argentinien: spanischsprachige Agenten, CSAT 95%, ab 3 $/h.',
      heroTitle: 'Call Center für Argentinien — Spanischsprachiger Support',
      heroSubtitle: 'Premium-Kundenservice für den argentinischen Markt.',
    },
    ar: {
      title: 'مركز اتصال الأرجنتين | خدمة عملاء بالإسبانية | Call IT Dev',
      description: 'مركز اتصال للأرجنتين: وكلاء ناطقون بالإسبانية، CSAT 95%، من 3 $/ساعة.',
      heroTitle: 'مركز اتصال للأرجنتين — دعم بالإسبانية',
      heroSubtitle: 'خدمة عملاء متميزة للسوق الأرجنتيني.',
    },
    pt: {
      title: 'Call Center Argentina | Atendimento em Espanhol | Call IT Dev',
      description: 'Call center para Argentina: agentes hispanófonos, CSAT 95%, a partir de 3 $/h.',
      heroTitle: 'Call Center para Argentina — Suporte em Espanhol',
      heroSubtitle: 'Atendimento premium para o mercado argentino.',
    },
    it: {
      title: 'Call Center Argentina | Assistenza in Spagnolo | Call IT Dev',
      description: 'Call center per l\'Argentina: agenti ispanofoni, CSAT 95%, da 3 $/h.',
      heroTitle: 'Call Center per l\'Argentina — Supporto in Spagnolo',
      heroSubtitle: 'Assistenza premium per il mercato argentino.',
    },
    zh: {
      title: '阿根廷呼叫中心 | 西班牙语客服 | Call IT Dev',
      description: '阿根廷呼叫中心：西班牙语座席，CSAT 95%，3美元/小时起。',
      heroTitle: '阿根廷呼叫中心 — 西班牙语支持',
      heroSubtitle: '为阿根廷市场提供优质客户服务。',
    },
    ru: {
      title: 'Колл-центр Аргентина | Испаноязычная поддержка | Call IT Dev',
      description: 'Колл-центр для Аргентины: испаноговорящие агенты, CSAT 95%, от 3 $/ч.',
      heroTitle: 'Колл-центр для Аргентины — Испаноязычная поддержка',
      heroSubtitle: 'Премиум-обслуживание для аргентинского рынка.',
    },
  },

  // ============ SOUTH AFRICA — expand beyond FR/AR ============
  'south-africa': {
    de: {
      title: 'Call Center Südafrika | Englischsprachiger Kundenservice | Call IT Dev',
      description: 'Call Center für Südafrika: englischsprachige Agenten, CSAT 95%, ab 3 $/h.',
      heroTitle: 'Call Center für Südafrika — Englischsprachiger Support',
      heroSubtitle: 'Premium-Kundenservice für den südafrikanischen Markt.',
    },
    es: {
      title: 'Call Center Sudáfrica | Atención al Cliente en Inglés | Call IT Dev',
      description: 'Call center para Sudáfrica: agentes anglófonos, CSAT 95%, desde 3 $/h.',
      heroTitle: 'Call Center para Sudáfrica — Soporte en Inglés',
      heroSubtitle: 'Atención al cliente premium para el mercado sudafricano.',
    },
    pt: {
      title: 'Call Center África do Sul | Atendimento em Inglês | Call IT Dev',
      description: 'Call center para África do Sul: agentes anglófonos, CSAT 95%, a partir de 3 $/h.',
      heroTitle: 'Call Center para África do Sul — Suporte em Inglês',
      heroSubtitle: 'Atendimento premium para o mercado sul-africano.',
    },
    zh: {
      title: '南非呼叫中心 | 英语客服外包 | Call IT Dev',
      description: '南非呼叫中心：英语座席，CSAT 95%，3美元/小时起。',
      heroTitle: '南非呼叫中心 — 英语客服支持',
      heroSubtitle: '为南非市场提供优质客户服务。',
    },
    ru: {
      title: 'Колл-центр ЮАР | Англоязычная поддержка | Call IT Dev',
      description: 'Колл-центр для ЮАР: англоговорящие агенты, CSAT 95%, от 3 $/ч.',
      heroTitle: 'Колл-центр для ЮАР — Англоязычная поддержка',
      heroSubtitle: 'Премиум-обслуживание для южноафриканского рынка.',
    },
    it: {
      title: 'Call Center Sudafrica | Assistenza in Inglese | Call IT Dev',
      description: 'Call center per il Sudafrica: agenti anglofoni, CSAT 95%, da 3 $/h.',
      heroTitle: 'Call Center per il Sudafrica — Supporto in Inglese',
      heroSubtitle: 'Assistenza premium per il mercato sudafricano.',
    },
  },

  // ============ PHILIPPINES — expand beyond FR/ES ============
  philippines: {
    de: {
      title: 'Call Center Philippinen | Premium Alternative | Call IT Dev',
      description: 'Premium-Alternative zum philippinischen BPO: CSAT 95%, CET-Zeitzone.',
      heroTitle: 'Call Center für Philippinen — Premium Nearshore Alternative',
      heroSubtitle: 'Qualitativ hochwertige Alternative zum Offshore-BPO.',
    },
    ar: {
      title: 'مركز اتصال الفلبين | بديل BPO متميز | Call IT Dev',
      description: 'بديل متميز لـ BPO الفلبيني: CSAT 95%، منطقة CET.',
      heroTitle: 'مركز اتصال للفلبين — بديل nearshore متميز',
      heroSubtitle: 'بديل عالي الجودة لـ BPO الفلبيني.',
    },
    zh: {
      title: '菲律宾呼叫中心 | 高端BPO替代 | Call IT Dev',
      description: '菲律宾BPO高端替代：CSAT 95%，CET时区。nearshore品质。',
      heroTitle: '菲律宾呼叫中心 — 高端替代方案',
      heroSubtitle: '优于离岸BPO的高品质替代。',
    },
    it: {
      title: 'Call Center Filippine | Alternativa Premium | Call IT Dev',
      description: 'Alternativa premium al BPO filippino: CSAT 95%, fuso CET.',
      heroTitle: 'Call Center Filippine — Alternativa Premium',
      heroSubtitle: 'Alternativa di qualità superiore al BPO offshore.',
    },
    ru: {
      title: 'Колл-центр Филиппины | Премиум альтернатива | Call IT Dev',
      description: 'Премиум-альтернатива филиппинскому BPO: CSAT 95%, CET.',
      heroTitle: 'Колл-центр Филиппины — Премиум альтернатива',
      heroSubtitle: 'Высококачественная альтернатива офшорному BPO.',
    },
    ja: {
      title: 'フィリピンコールセンター | プレミアム代替 | Call IT Dev',
      description: 'フィリピンBPOのプレミアム代替：CSAT 95%、CET時間帯。',
      heroTitle: 'フィリピンコールセンター — プレミアム代替',
      heroSubtitle: 'オフショアBPOの高品質代替。',
    },
    ko: {
      title: '필리핀 콜센터 | 프리미엄 대안 | Call IT Dev',
      description: '필리핀 BPO 프리미엄 대안: CSAT 95%, CET 시간대.',
      heroTitle: '필리핀 콜센터 — 프리미엄 대안',
      heroSubtitle: '오프쇼어 BPO의 고품질 대안.',
    },
    tr: {
      title: 'Filipinler Çağrı Merkezi | Premium Alternatif | Call IT Dev',
      description: 'Filipin BPO\'suna premium alternatif: CSAT %95, CET.',
      heroTitle: 'Filipinler Çağrı Merkezi — Premium Alternatif',
      heroSubtitle: 'Offshore BPO\'ya yüksek kaliteli alternatif.',
    },
  },

  // ============ NIGERIA — expand beyond FR/AR ============
  nigeria: {
    de: {
      title: 'Call Center Nigeria | Englischsprachiger Support Afrika | Call IT Dev',
      description: 'Call Center für Nigeria: englischsprachige Agenten, CSAT 95%, ab 3 $/h.',
      heroTitle: 'Call Center für Nigeria — Englischsprachiger Afrika-Support',
      heroSubtitle: 'Premium-Kundenservice für den nigerianischen Markt.',
    },
    es: {
      title: 'Call Center Nigeria | Atención al Cliente África | Call IT Dev',
      description: 'Call center para Nigeria: agentes anglófonos, CSAT 95%, desde 3 $/h.',
      heroTitle: 'Call Center para Nigeria — Soporte África',
      heroSubtitle: 'Atención al cliente premium para el mercado nigeriano.',
    },
    zh: {
      title: '尼日利亚呼叫中心 | 英语客服非洲 | Call IT Dev',
      description: '尼日利亚呼叫中心：英语座席，CSAT 95%，3美元/小时起。',
      heroTitle: '尼日利亚呼叫中心 — 英语客服支持',
      heroSubtitle: '为尼日利亚市场提供优质客户服务。',
    },
    pt: {
      title: 'Call Center Nigéria | Atendimento África | Call IT Dev',
      description: 'Call center para Nigéria: agentes anglófonos, CSAT 95%, a partir de 3 $/h.',
      heroTitle: 'Call Center para Nigéria — Suporte África',
      heroSubtitle: 'Atendimento premium para o mercado nigeriano.',
    },
    ru: {
      title: 'Колл-центр Нигерия | Англоязычная поддержка | Call IT Dev',
      description: 'Колл-центр для Нигерии: англоговорящие агенты, CSAT 95%, от 3 $/ч.',
      heroTitle: 'Колл-центр для Нигерии — Англоязычная поддержка',
      heroSubtitle: 'Премиум-обслуживание для нигерийского рынка.',
    },
  },

  // ============ KENYA — expand beyond FR/AR ============
  kenya: {
    de: {
      title: 'Call Center Kenia | Englischsprachiger Support Ostafrika | Call IT Dev',
      description: 'Call Center für Kenia: englischsprachige Agenten, CSAT 95%, ab 3 $/h.',
      heroTitle: 'Call Center für Kenia — Ostafrika-Support',
      heroSubtitle: 'Premium-Kundenservice für den kenianischen Markt.',
    },
    es: {
      title: 'Call Center Kenia | Atención al Cliente África Oriental | Call IT Dev',
      description: 'Call center para Kenia: agentes anglófonos, CSAT 95%, desde 3 $/h.',
      heroTitle: 'Call Center para Kenia — Soporte África Oriental',
      heroSubtitle: 'Atención al cliente premium para el mercado keniano.',
    },
    zh: {
      title: '肯尼亚呼叫中心 | 东非英语客服 | Call IT Dev',
      description: '肯尼亚呼叫中心：英语座席，CSAT 95%，3美元/小时起。',
      heroTitle: '肯尼亚呼叫中心 — 东非客服支持',
      heroSubtitle: '为肯尼亚市场提供优质客户服务。',
    },
    pt: {
      title: 'Call Center Quênia | Atendimento África Oriental | Call IT Dev',
      description: 'Call center para Quênia: agentes anglófonos, CSAT 95%, a partir de 3 $/h.',
      heroTitle: 'Call Center para Quênia — Suporte África Oriental',
      heroSubtitle: 'Atendimento premium para o mercado queniano.',
    },
    it: {
      title: 'Call Center Kenya | Assistenza Africa Orientale | Call IT Dev',
      description: 'Call center per il Kenya: agenti anglofoni, CSAT 95%, da 3 $/h.',
      heroTitle: 'Call Center per il Kenya — Supporto Africa Orientale',
      heroSubtitle: 'Assistenza premium per il mercato keniano.',
    },
    ru: {
      title: 'Колл-центр Кения | Поддержка Восточная Африка | Call IT Dev',
      description: 'Колл-центр для Кении: англоговорящие агенты, CSAT 95%, от 3 $/ч.',
      heroTitle: 'Колл-центр для Кении — Поддержка Восточная Африка',
      heroSubtitle: 'Премиум-обслуживание для кенийского рынка.',
    },
  },

  // ============ Expand remaining countries with few languages ============

  // ITALY — add more languages
  italy: {
    de: {
      title: 'Call Center Italien | Italienischsprachiger Kundenservice | Call IT Dev',
      description: 'Call Center für Italien: italienischsprachige Agenten, CSAT 95%, ab 3 $/h. 55% Ersparnis vs Mailand.',
      heroTitle: 'Call Center für Italien — Italienischsprachiger Support',
      heroSubtitle: 'Premium-Kundenservice auf Italienisch zu Nearshore-Preisen.',
    },
    es: {
      title: 'Call Center Italia | Atención al Cliente en Italiano | Call IT Dev',
      description: 'Call center para Italia: agentes italófonos, CSAT 95%, desde 3 $/h. 55% ahorro vs Milán.',
      heroTitle: 'Call Center para Italia — Soporte en Italiano',
      heroSubtitle: 'Atención al cliente premium en italiano.',
    },
    ar: {
      title: 'مركز اتصال إيطاليا | خدمة عملاء بالإيطالية | Call IT Dev',
      description: 'مركز اتصال لإيطاليا: وكلاء ناطقون بالإيطالية، CSAT 95%، من 3 $/ساعة.',
      heroTitle: 'مركز اتصال لإيطاليا — دعم بالإيطالية',
      heroSubtitle: 'خدمة عملاء متميزة بالإيطالية.',
    },
    zh: {
      title: '意大利呼叫中心 | 意大利语客服外包 | Call IT Dev',
      description: '意大利呼叫中心外包：意大利语母语座席，CSAT 95%，3美元/小时起。',
      heroTitle: '意大利呼叫中心 — 意大利语客服支持',
      heroSubtitle: '以nearshore价格提供优质意大利语客户体验。',
    },
    ja: {
      title: 'イタリアコールセンター | イタリア語サポート | Call IT Dev',
      description: 'イタリア向けコールセンター：イタリア語ネイティブ、CSAT 95%、3$/時間〜。',
      heroTitle: 'イタリア向けコールセンター — イタリア語サポート',
      heroSubtitle: 'ニアショア価格でプレミアムなイタリア語体験。',
    },
    ko: {
      title: '이탈리아 콜센터 | 이탈리아어 고객 서비스 | Call IT Dev',
      description: '이탈리아 콜센터: 이탈리아어 원어민 상담원, CSAT 95%, 시간당 3달러부터.',
      heroTitle: '이탈리아 콜센터 — 이탈리아어 지원',
      heroSubtitle: '니어쇼어 가격으로 프리미엄 이탈리아어 경험.',
    },
    ru: {
      title: 'Колл-центр Италия | Италоязычная поддержка | Call IT Dev',
      description: 'Колл-центр для Италии: италоговорящие агенты, CSAT 95%, от 3 $/ч.',
      heroTitle: 'Колл-центр для Италии — Италоязычная поддержка',
      heroSubtitle: 'Премиум-обслуживание на итальянском.',
    },
    pt: {
      title: 'Call Center Itália | Atendimento em Italiano | Call IT Dev',
      description: 'Call center para Itália: agentes italófonos, CSAT 95%, a partir de 3 $/h.',
      heroTitle: 'Call Center para Itália — Suporte em Italiano',
      heroSubtitle: 'Atendimento premium em italiano.',
    },
    nl: {
      title: 'Callcenter Italië | Italiaanstalige Klantenservice | Call IT Dev',
      description: 'Callcenter voor Italië: Italiaanstalige agenten, CSAT 95%, vanaf 3 $/u.',
      heroTitle: 'Callcenter voor Italië — Italiaanstalige Klantenservice',
      heroSubtitle: 'Premium klantenservice in het Italiaans.',
    },
    pl: {
      title: 'Call Center Włochy | Obsługa po Włosku | Call IT Dev',
      description: 'Call center dla Włoch: agenci włoskojęzyczni, CSAT 95%, od 3 $/h.',
      heroTitle: 'Call Center dla Włoch — Obsługa po Włosku',
      heroSubtitle: 'Premium obsługa klienta po włosku.',
    },
    tr: {
      title: 'İtalya Çağrı Merkezi | İtalyanca Müşteri Hizmetleri | Call IT Dev',
      description: 'İtalya için çağrı merkezi: İtalyanca konuşan acenteler, CSAT %95.',
      heroTitle: 'İtalya İçin Çağrı Merkezi — İtalyanca Destek',
      heroSubtitle: 'Premium İtalyanca müşteri deneyimi.',
    },
    sv: {
      title: 'Callcenter Italien | Italiensktalande Kundtjänst | Call IT Dev',
      description: 'Callcenter för Italien: italiensktalande agenter, CSAT 95%, från 3 $/h.',
      heroTitle: 'Callcenter för Italien — Italiensktalande Kundtjänst',
      heroSubtitle: 'Premium kundtjänst på italienska.',
    },
    da: {
      title: 'Callcenter Italien | Italiensktalende Kundeservice | Call IT Dev',
      description: 'Callcenter til Italien: italiensktalende agenter, CSAT 95%, fra 3 $/t.',
      heroTitle: 'Callcenter til Italien — Italiensktalende Kundeservice',
      heroSubtitle: 'Premium kundeservice på italiensk.',
    },
  },

  // PORTUGAL — add more languages
  portugal: {
    de: {
      title: 'Call Center Portugal | Portugiesischsprachiger Kundenservice | Call IT Dev',
      description: 'Call Center für Portugal: portugiesischsprachige Agenten, CSAT 95%, ab 3 $/h. 50% Ersparnis.',
      heroTitle: 'Call Center für Portugal — Portugiesischsprachiger Support',
      heroSubtitle: 'Premium-Kundenservice auf Portugiesisch.',
    },
    es: {
      title: 'Call Center Portugal | Atención al Cliente en Portugués | Call IT Dev',
      description: 'Call center para Portugal: agentes lusófonos, CSAT 95%, desde 3 $/h. 50% ahorro.',
      heroTitle: 'Call Center para Portugal — Soporte en Portugués',
      heroSubtitle: 'Atención al cliente premium en portugués.',
    },
    ar: {
      title: 'مركز اتصال البرتغال | خدمة عملاء بالبرتغالية | Call IT Dev',
      description: 'مركز اتصال للبرتغال: وكلاء ناطقون بالبرتغالية، CSAT 95%، من 3 $/ساعة.',
      heroTitle: 'مركز اتصال للبرتغال — دعم بالبرتغالية',
      heroSubtitle: 'خدمة عملاء متميزة بالبرتغالية.',
    },
    it: {
      title: 'Call Center Portogallo | Assistenza in Portoghese | Call IT Dev',
      description: 'Call center per il Portogallo: agenti lusofoni, CSAT 95%, da 3 $/h.',
      heroTitle: 'Call Center per il Portogallo — Supporto in Portoghese',
      heroSubtitle: 'Assistenza premium in portoghese.',
    },
    nl: {
      title: 'Callcenter Portugal | Portugeestalige Klantenservice | Call IT Dev',
      description: 'Callcenter voor Portugal: Portugeestalige agenten, CSAT 95%, vanaf 3 $/u.',
      heroTitle: 'Callcenter voor Portugal — Portugeestalige Klantenservice',
      heroSubtitle: 'Premium klantenservice in het Portugees.',
    },
    zh: {
      title: '葡萄牙呼叫中心 | 葡萄牙语客服外包 | Call IT Dev',
      description: '葡萄牙呼叫中心：葡萄牙语座席，CSAT 95%，3美元/小时起。',
      heroTitle: '葡萄牙呼叫中心 — 葡萄牙语客服',
      heroSubtitle: '以nearshore价格提供优质葡萄牙语体验。',
    },
    ru: {
      title: 'Колл-центр Португалия | Португалоязычная поддержка | Call IT Dev',
      description: 'Колл-центр для Португалии: португалоговорящие агенты, CSAT 95%, от 3 $/ч.',
      heroTitle: 'Колл-центр для Португалии — Португалоязычная поддержка',
      heroSubtitle: 'Премиум-обслуживание на португальском.',
    },
  },

  // POLAND — add more languages
  poland: {
    de: {
      title: 'Call Center Polen | Mehrsprachiger Kundenservice | Call IT Dev',
      description: 'Call Center für Polen: mehrsprachige Agenten, CSAT 95%, ab 3 $/h. 50% Ersparnis.',
      heroTitle: 'Call Center für Polen — Mehrsprachiger Support',
      heroSubtitle: 'Premium-Kundenservice für den polnischen Markt.',
    },
    es: {
      title: 'Call Center Polonia | Atención al Cliente Multilingüe | Call IT Dev',
      description: 'Call center para Polonia: agentes multilingües, CSAT 95%, desde 3 $/h.',
      heroTitle: 'Call Center para Polonia — Soporte Multilingüe',
      heroSubtitle: 'Atención al cliente premium para el mercado polaco.',
    },
    ar: {
      title: 'مركز اتصال بولندا | خدمة عملاء متعددة اللغات | Call IT Dev',
      description: 'مركز اتصال لبولندا: وكلاء متعددو اللغات، CSAT 95%، من 3 $/ساعة.',
      heroTitle: 'مركز اتصال لبولندا — دعم متعدد اللغات',
      heroSubtitle: 'خدمة عملاء متميزة للسوق البولندي.',
    },
    it: {
      title: 'Call Center Polonia | Assistenza Multilingue | Call IT Dev',
      description: 'Call center per la Polonia: agenti multilingue, CSAT 95%, da 3 $/h.',
      heroTitle: 'Call Center per la Polonia — Supporto Multilingue',
      heroSubtitle: 'Assistenza premium per il mercato polacco.',
    },
    zh: {
      title: '波兰呼叫中心 | 多语种客服外包 | Call IT Dev',
      description: '波兰呼叫中心：多语种座席，CSAT 95%，3美元/小时起。',
      heroTitle: '波兰呼叫中心 — 多语种客服支持',
      heroSubtitle: '以nearshore价格提供波兰市场优质客户服务。',
    },
    ru: {
      title: 'Колл-центр Польша | Многоязычная поддержка | Call IT Dev',
      description: 'Колл-центр для Польши: многоязычные агенты, CSAT 95%, от 3 $/ч.',
      heroTitle: 'Колл-центр для Польши — Многоязычная поддержка',
      heroSubtitle: 'Премиум-обслуживание для польского рынка.',
    },
    pt: {
      title: 'Call Center Polônia | Atendimento Multilingue | Call IT Dev',
      description: 'Call center para Polônia: agentes multilingues, CSAT 95%, a partir de 3 $/h.',
      heroTitle: 'Call Center para Polônia — Suporte Multilingue',
      heroSubtitle: 'Atendimento premium para o mercado polonês.',
    },
    nl: {
      title: 'Callcenter Polen | Meertalige Klantenservice | Call IT Dev',
      description: 'Callcenter voor Polen: meertalige agenten, CSAT 95%, vanaf 3 $/u.',
      heroTitle: 'Callcenter voor Polen — Meertalige Klantenservice',
      heroSubtitle: 'Premium klantenservice voor de Poolse markt.',
    },
  },

  // TURKEY — add more languages
  turkey: {
    de: {
      title: 'Call Center Türkei | Türkischsprachiger Kundenservice | Call IT Dev',
      description: 'Call Center für Türkei: türkischsprachige Agenten, CSAT 95%, ab 3 $/h. 50% Ersparnis.',
      heroTitle: 'Call Center für die Türkei — Türkischsprachiger Support',
      heroSubtitle: 'Premium-Kundenservice auf Türkisch.',
    },
    es: {
      title: 'Call Center Turquía | Atención al Cliente en Turco | Call IT Dev',
      description: 'Call center para Turquía: agentes turcófonos, CSAT 95%, desde 3 $/h.',
      heroTitle: 'Call Center para Turquía — Soporte en Turco',
      heroSubtitle: 'Atención al cliente premium en turco.',
    },
    ar: {
      title: 'مركز اتصال تركيا | خدمة عملاء بالتركية | Call IT Dev',
      description: 'مركز اتصال لتركيا: وكلاء ناطقون بالتركية، CSAT 95%، من 3 $/ساعة.',
      heroTitle: 'مركز اتصال لتركيا — دعم بالتركية',
      heroSubtitle: 'خدمة عملاء متميزة بالتركية.',
    },
    it: {
      title: 'Call Center Turchia | Assistenza in Turco | Call IT Dev',
      description: 'Call center per la Turchia: agenti turcofoni, CSAT 95%, da 3 $/h.',
      heroTitle: 'Call Center per la Turchia — Supporto in Turco',
      heroSubtitle: 'Assistenza premium in turco.',
    },
    zh: {
      title: '土耳其呼叫中心 | 土耳其语客服外包 | Call IT Dev',
      description: '土耳其呼叫中心：土耳其语座席，CSAT 95%，3美元/小时起。',
      heroTitle: '土耳其呼叫中心 — 土耳其语客服支持',
      heroSubtitle: '以nearshore价格提供优质土耳其语体验。',
    },
    ru: {
      title: 'Колл-центр Турция | Туркоязычная поддержка | Call IT Dev',
      description: 'Колл-центр для Турции: туркоговорящие агенты, CSAT 95%, от 3 $/ч.',
      heroTitle: 'Колл-центр для Турции — Туркоязычная поддержка',
      heroSubtitle: 'Премиум-обслуживание на турецком.',
    },
    pt: {
      title: 'Call Center Turquia | Atendimento em Turco | Call IT Dev',
      description: 'Call center para Turquia: agentes turcófonos, CSAT 95%, a partir de 3 $/h.',
      heroTitle: 'Call Center para Turquia — Suporte em Turco',
      heroSubtitle: 'Atendimento premium em turco.',
    },
    nl: {
      title: 'Callcenter Turkije | Turkstalige Klantenservice | Call IT Dev',
      description: 'Callcenter voor Turkije: Turkstalige agenten, CSAT 95%, vanaf 3 $/u.',
      heroTitle: 'Callcenter voor Turkije — Turkstalige Klantenservice',
      heroSubtitle: 'Premium klantenservice in het Turks.',
    },
    pl: {
      title: 'Call Center Turcja | Obsługa po Turecku | Call IT Dev',
      description: 'Call center dla Turcji: agenci tureckojęzyczni, CSAT 95%, od 3 $/h.',
      heroTitle: 'Call Center dla Turcji — Obsługa po Turecku',
      heroSubtitle: 'Premium obsługa klienta po turecku.',
    },
  },
};
